// wraps promise to never throw, return tuple with error/data instead
export const prom = <T>(
  p: Promise<T> | (() => Promise<T>)
): Promise<
  readonly [error: null, result: T] | readonly [error: string, result: null]
> =>
  (typeof p === "function" ? p() : p)
    .then((res) => {
      if (res instanceof Response && !res.ok)
        throw Error(`${res.status}: ${res.statusText}`);

      return [null, res] as const;
    })
    .catch((err) => {
      let msg = "";
      if (err instanceof Error) msg = err.message;

      try {
        msg = msg || JSON.stringify(err);
      } catch (error) {
        msg = String(err);
      }

      return [msg, null] as const;
    });
